import CrudService from "../common/CrudService";

class CenterService extends CrudService {
  get endpoint() {
    return "/api/centers";
  }
}

export default new CenterService();
